import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import { setGA4Event } from "@tggstore/Handlers/Utilities/CustomTracking";
import loadProductCategories from "@tggstore/Store/Handlers/Custom/LoadProductCategories";
import { CustomState } from "@tggstore/Store/Reducers";

addToChainAfter(chain, ExecuteOnSuccessCallback,  props => {
    if (props.apiResult) {
        const state = props.getState() as CustomState;
        const session = state.context.session;
        const cartState = getCurrentCartState(state).value;
        
        const cartLinesParameters= props.apiParameter.cartLines ?? [];
        const cartLines = props.apiResult.cartLines ?? [];
        
        const currency = session?.currency?.currencyCode || "";
        const billToCustomerName = getBillToState(state, cartState?.billToId)?.value?.customerNumber ?? "";
        const indexes: Array<{ id: string; attribute: string }> = [];
        let count =0;
        cartLines.forEach(cartLine => {
            const auxLine = cartLinesParameters.find(line => line.productId === cartLine.productId);            
            if (auxLine && auxLine.qtyOrdered !== cartLine.qtyOrdered) {
                cartLine.qtyOrdered = auxLine.qtyOrdered;
            }
            indexes.push({
                id: cartLine.productId!,
                attribute: `${count}`, 
            });
            count++;
        });

        const productIds = cartLines.map(o => o.productId).filter((id): id is string => id !== null);
        const cartlinesSubTotal = cartLines.reduce((acc, line) => {
            const price = line.pricing?.actualPrice ?? 0;
            const qty = line.qtyOrdered ?? 0;
            return acc + price * qty;
        }, 0);


        props.dispatch(
            loadProductCategories({
                productIds,
                type: "cart",
                onSuccess: data => {
                    setGA4Event(cartLines, "add_to_cart", {
                        currency,
                        value: cartlinesSubTotal,
                        affiliation: state.customDefaultWarehouse.warehouse?.description || "",
                        account_number: billToCustomerName,
                        productCategories: data,
                        indexes,
                    });
                },
            }),
        );
    }
});
